import StaffCustomers from '@screens/staff/customers'

export default function StaffCustomersPage() {
  return <StaffCustomers />
}
